<template>
  <div class="Container" v-cypress="$cypress.user.account.container">
    <div class="UserAccount-Hero">
      <span v-if="isHome" class="UserAccount-WelcomeMessage">
        <span class="WelcomeMessage">{{ welcomeMessage }}</span>
      </span>
    </div>

    <router-view></router-view>
  </div>
</template>

<script>
import userMixin from '@/mixins/user'

export default {
  name: 'UserAccount',
  mixins: [userMixin],
  computed: {
    isHome() {
      return this.$route.name === 'userAccountHome'
    },
    welcomeMessage() {
      if (this.firstname) {
        return this.$t('userAccount.welcomeMessage', { firstname: this.firstname })
      } else {
        return this.$t('userAccount.anonymousWelcomeMessage')
      }
    }
  },
  data: () => ({
    firstname: ''
  }),
  mounted() {
    if (this.user && this.user.firstname && this.user.firstname !== '') {
      this.firstname = this.user.firstname
    }
  }
}
</script>

<style scoped lang="scss">
.Container {
  box-sizing: border-box;
}

.UserAccount-Hero {
  text-align: left;
}

.Back-Container {
  cursor: pointer;
}

.BackButton {
  margin-left: 15px;
  text-decoration: underline;
}

.WelcomeMessage {
  margin-left: 25px;
}
</style>
